import ProductInfo from "components/GroupShoppingList/ProductInfo";
import Range1 from "components/GroupShoppingList/Range";
import StatisticalInformation from "components/GroupShoppingList/StatisticalInformation";
import { useState, useEffect } from "react";
import mos from "assets/images/mos.png";
import headphone from "assets/images/headphone.png";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import Pagination from "rc-pagination";
import Loader from "utils/Loader";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import { GoChecklist } from "react-icons/go";
import Title from "common/Title";
import Helmet from "react-helmet";
import { useParams } from "react-router-dom";

export default function GroupShoppingList({ typeLogin, logo, type }) {
  const [productInfo, setProductInfo] = useState([]);
  const [range, setRange] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const auth = useContext(WithAuthentication);
  const [updater, setUpdater] = useState(false);
  const shop_id = useParams();

  useEffect(() => {
    async function LoadPage() {
      if (typeLogin == "adminShop") {
        await sendRequest2("getgroupproduct", {
          shop_id: shop_id.supplierId,
        }).then(({ data }) => {
          setProductInfo(data.items);
          setRange(data.items.range);
        });
        setIsLoading(false);
      } else {
        await sendRequest2("getgroupproduct").then(({ data }) => {
          setProductInfo(data.items);
          setRange(data.items.range);
        });
        setIsLoading(false);
      }
    }
    LoadPage();
  }, [updater]);
  console.log("shoping:", productInfo);
  // console.log("renge:", productInfo.range[0]);
  let typeUser = "shop";
  return (
    <>
      <Helmet>
        <title> لیست خرید گروهی </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      <Title
        color="rgb(244 124 96)"
        title="لیست خرید گروهی"
        icon={GoChecklist}
      />
      <>
        {productInfo ? (
          <div className="Group-container px-3 mx-0 ">
            {isLoading && <Loader></Loader>}

            {[...productInfo]
              ?.reverse()
              ?.slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
              .map((value, index) => {
                return (
                  <div
                    style={{
                      backgroundColor: "#f6f6fe",
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      marginTop: "25px",
                      borderRadius: "10px",
                      padding: "15px",
                    }}
                  >
                    <ProductInfo
                      productInfo={value}
                      setProductInfo={setProductInfo}
                    ></ProductInfo>
                    <Range1 range={value} setRange={setRange}></Range1>
                    <StatisticalInformation
                      productInfo={value}
                      setProductInfo={setProductInfo}
                      typeUser={typeUser}
                      updater={updater}
                      setUpdater={setUpdater}
                      stortype={shop_id.stortype}
                      type={type}
                      userType={auth.userInfo.userType}
                    ></StatisticalInformation>
                  </div>
                );
              })}
          </div>
        ) : (
          " در حال حاضرلیستی وجودندارد"
        )}
        <div className="d-flex justify-content-center mt-4">
          <div>
            <Pagination
              total={productInfo?.length}
              pageSize={5}
              current={currentPage}
              onChange={(newPage) => {
                setCurrentPage(newPage);
              }}
            ></Pagination>
          </div>
        </div>
      </>
    </>
  );
}
